import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { ReactNode } from "react";
import { useAuth } from "./AuthContext";
import { useNavigate } from "react-router-dom";
import ButtonAppBar from "../components/ButtonAppBar";
import './DefaultLayout.css';

interface DefaultLayoutProps {
    children?: ReactNode;
}

const DefaultLayout = ({ children }: DefaultLayoutProps) => {
    const { appUser } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        // Only navigate if we're sure the user is not authenticated
        if (appUser === null) {
            navigate('/signin');
        }
    }, [appUser, navigate]);

    // Show nothing while we're still loading the auth state
    if (appUser === undefined) {
        return null;
    }

    // If we have a user and they're verified and an admin, show the layout
    if (appUser?.user?.emailVerified && appUser?.role === "admin") {
        return (
            <div className="layout-container">
                <header>
                    <ButtonAppBar />
                </header>
                <main className="content-container">
                    {children || <Outlet />}
                </main>
                <footer className="footer">
                    <div>Footer</div>
                </footer>
            </div>
        );
    }

    // Otherwise, they'll be redirected by the useEffect
    return null;
}

export default DefaultLayout;